import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';

import { useObservationsSection } from '../context/ObservationsSectionContext';

const ObservationsSectionHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useObservationsSection();

  const buttonDisabled = data.isAdmin && !data.isReadOnly;

  return (
    <div className="nk-block-between d-flex flex-column flex-md-row">
      <div className="nk-block-head-content">
        <h4 className="nk-block-title">{t('Observations')}</h4>
        <div className="nk-block-des">
          <p>{t('ObservationsTabDescription')}</p>
        </div>
      </div>

      {/* <div className="nk-block-head-content">
        <div className="nk-block float-right">
          <Button
            onClick={actions.handleAddObservation}
            disabled={buttonDisabled}
          >
            <em className="icon ni ni-plus" />
            <span>{t('AddObservation')}</span>
          </Button>
        </div>
      </div> */}
    </div>
  );
};

export default ObservationsSectionHeader;
